module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAO9JREFUWAljYBgFoyEwGgKjIUClEPj//38xEC8GYlYqGUmcMUALGYG4B4hhYBeQwUOcbiqoAlqmBMSvYLZD6TNAWowKxhNnBNAyVSC+B7UcRt0BMpSJM4EKqoCWSQLxBZjtUPolkDamgvHEGQG0jA+I9wMxMvgM5LjiMoERXQKoeCa6GIl8dqD6aCBmQdL3G8hOYGRkXIYkhp2J7HQqs/8BzStGt5UJXYDefORggtk9C8Ygk6YsCsi0FKwNGMQkJ0JK7EPRC7R84LIh0PKBK4iAlg9sUQx0wMBWRrCEAHTIwFTHMAeM0qMhMBoCQzYEAOQQdgSxR/GmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic_right@4x.png
// module id = 1458
// module chunks = 0